import { toast } from 'sonner';

export function extractErrorMessage(error: any): string {
  if (!error) {
    return 'Erro desconhecido.';
  }

  if (typeof error === 'string') {
    return error;
  }

  const message =
    error?.response?.data?.errors?.[0]?.description ||
    error?.data?.errors?.[0]?.description ||
    error?.errors?.[0]?.description ||
    error?.data?.data?.error ||
    error?.data?.data?.message ||
    error?.response?.data?.data?.error ||
    error?.response?.data?.data?.message ||
    error?.data?.error ||
    error?.response?.data?.error ||
    error?.data?.message ||
    error?.response?.data?.message ||
    error?.error ||
    error?.message;

  if (message && typeof message === 'string') {
    return message;
  }

  return 'Erro ao processar solicitação.';
}

export function showError(error: any) {
  const message = extractErrorMessage(error);
  toast.error(message);
}

export { toast };
